import { useCurrentDossierCtx } from '@europrocurement/l2d-modules/modules/Dossiers/providers/CurrentDossierProvider';
import React, { ReactNode, useMemo } from 'react';
import { DossierDocumentsProvider } from './DossierDocumentsProvider';

type Props = { children: ReactNode };

/**
 * Reads sibling dossier IDs from CurrentDossierProvider and wraps children
 * with DossierDocumentsProvider scoped to all siblings.
 */
const DossierDocumentsProviderWrapper: React.FunctionComponent<Props> = function ({ children }) {
    const { siblings } = useCurrentDossierCtx();

    const dossierIds = useMemo(
        () => siblings?.filter((doss) => !doss.deleted).map((d) => d.id as number) ?? [],
        [siblings],
    );

    return (
        <DossierDocumentsProvider
            autoload
            dossierIds={dossierIds}
        >
            {children}
        </DossierDocumentsProvider>
    );
};

export default DossierDocumentsProviderWrapper;
